import fetchJSON from '../fetchJSON';
import {memoize, flatten} from 'lodash';

type Geometry = GeoJSON.MultiLineString | GeoJSON.LineString | GeoJSON.Point;

function fetchElevation(
    geometry: GeoJSON.Point,
    elevation?: number
): Promise<GeoJSON.Point>;

function fetchElevation(
    geometry: GeoJSON.LineString,
    elevation?: number
): Promise<GeoJSON.LineString>;

function fetchElevation(
    geometry: GeoJSON.MultiLineString,
    elevation?: number
): Promise<GeoJSON.MultiLineString>;

async function fetchElevation(
    geometry: GeoJSON.Geometry,
    elevation?: number
): Promise<GeoJSON.Geometry> {

    if (
        geometry.type === 'MultiLineString' && (
            flatten(geometry.coordinates).length === 0 ||
            flatten(geometry.coordinates)[0][2]
        )
    ) {
        return geometry;

    } else if (
        geometry.type === 'LineString' && (
            geometry.coordinates.length === 0 ||
            geometry.coordinates[0][2]
        )
    ) {
        return geometry;

    } else if (geometry.type === 'Point' && geometry.coordinates[2]) {
        return geometry;

    } else if (geometry.type === 'Point' && elevation) {
        return {
            type: 'Point',
            coordinates: [
                geometry.coordinates[0],
                geometry.coordinates[1],
                elevation
            ]
        };

    } else {
        return await fetchJSON('https://elevation.gaiagps.com/geojson/', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(geometry)
        });
    }

}

export default memoize<typeof fetchElevation>(
    fetchElevation,
    (geometry, elevation) => JSON.stringify([geometry, elevation])
);
